(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("vue-scrollwatch", [], factory);
	else if(typeof exports === 'object')
		exports["vue-scrollwatch"] = factory();
	else
		root["vue-scrollwatch"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bezier_easing__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bezier_easing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bezier_easing__);



//   滚动监听组件

var nodeList = [];
var scrollDom = document.querySelector("html");
var container = '';
var cubicBezierArray = [0.5, 0, 0.35, 1];
var duration = 600;
var scrollAnimationFrame = null;
var handleScroll = function handleScroll() {

    var scrollTop = getScrollTop(scrollDom);
    var result = null;

    nodeList.forEach(function (item) {
        if (getOppositeOffsetToContainer(item.el) - item.offset <= scrollTop) {
            result = item;
        }
    });
    dealResult(result);
};
var getScrollTop = function getScrollTop(el) {
    if (container) return el.scrollTop;
    var scrollTop = document.documentElement.scrollTop == 0 ? document.body.scrollTop : document.documentElement.scrollTop;
    return scrollTop;
};
var getOppositeOffsetToContainer = function getOppositeOffsetToContainer(el) {
    return getOffsetTopByEl(el) - getOffsetTopByEl(scrollDom);
};
var getOffsetTopByEl = function getOffsetTopByEl(element) {
    var yPosition = 0;
    var nextElement = element;

    while (nextElement) {
        yPosition += nextElement.offsetTop;
        nextElement = nextElement.offsetParent;
    }

    return yPosition;
};
var dealResult = function dealResult(result) {
    if (result && result.callback) result.callback(result);
};
var scrollTo = function scrollTo(name) {

    // target node
    var node = nodeList.find(function (v) {
        return v.name == name;
    });
    var startingY = getScrollTop(scrollDom);
    var difference = getOppositeOffsetToContainer(node.el) - startingY;
    var easing = __WEBPACK_IMPORTED_MODULE_0_bezier_easing___default.a.apply(undefined, cubicBezierArray);
    var start = null;
    var step = function step(timestamp) {
        if (!start) start = timestamp;
        var progress = timestamp - start >= duration ? duration : timestamp - start;
        var progressPercentage = progress / duration;
        var perTick = startingY + easing(progressPercentage) * (difference - node.offset);

        moveTo(perTick);

        if (progress < duration) {
            scrollAnimationFrame = window.requestAnimationFrame(step);
        }
    };
    window.requestAnimationFrame(step);
};
var moveTo = function moveTo(scrollTop) {
    if (container) {
        if (scrollDom.scrollTo) {
            scrollDom.scrollTo(0, scrollTop);
        } else {
            scrollDom.scrollTop = scrollTop;
        }
        return;
    }
    document.documentElement.scrollTop = scrollTop;
    document.body.scrollTop = scrollTop;
};
var setContainer = function setContainer(dom) {
    container = dom;
};

var vueScrollwatch = {};
vueScrollwatch.install = function (Vue) {
    Vue.directive('scrollWatch', {
        inserted: function inserted(el, binding, vnode) {

            if (container) scrollDom = document.querySelector(container);
            var containerDom = container ? scrollDom : window;
            if (!containerDom) {
                console.error('[vue-scrollwatch] Element \'' + container + '\' was not found. ');
                return;
            }

            if (nodeList.length == 0) {
                containerDom.addEventListener('scroll', handleScroll);
            }
            var _binding$value = binding.value,
                name = _binding$value.name,
                _binding$value$offset = _binding$value.offset,
                offset = _binding$value$offset === undefined ? 0 : _binding$value$offset,
                callback = _binding$value.callback;


            nodeList.push({ name: name, offset: offset, top: el.offsetTop - offset, el: el, callback: callback });
            nodeList.sort(function (a, b) {
                return a.top - b.top;
            });
        },

        unbind: function unbind(el, binding, vnode) {
            var containerDom = container ? scrollDom : window;

            nodeList = nodeList.filter(function (node) {
                return node.name != binding.value.name;
            });
            if (nodeList.length == 0 && scrollDom) {

                containerDom.removeEventListener('scroll', handleScroll);
                container = '';
            }

            // 如果正在动画，则停止
            cancelAnimationFrame(scrollAnimationFrame);
        }
    });
};

vueScrollwatch.scrollTo = scrollTo;
vueScrollwatch.setContainer = setContainer;
/* harmony default export */ __webpack_exports__["default"] = (vueScrollwatch);

/***/ }),
/* 1 */
/***/ (function(module, exports) {

/**
 * https://github.com/gre/bezier-easing
 * BezierEasing - use bezier curve for transition easing function
 * by Gaëtan Renaudeau 2014 - 2015 – MIT License
 */

// These values are established by empiricism with tests (tradeoff: performance VS precision)
var NEWTON_ITERATIONS = 4;
var NEWTON_MIN_SLOPE = 0.001;
var SUBDIVISION_PRECISION = 0.0000001;
var SUBDIVISION_MAX_ITERATIONS = 10;

var kSplineTableSize = 11;
var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);

var float32ArraySupported = typeof Float32Array === 'function';

function A (aA1, aA2) { return 1.0 - 3.0 * aA2 + 3.0 * aA1; }
function B (aA1, aA2) { return 3.0 * aA2 - 6.0 * aA1; }
function C (aA1)      { return 3.0 * aA1; }

// Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
function calcBezier (aT, aA1, aA2) { return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT; }

// Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
function getSlope (aT, aA1, aA2) { return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1); }

function binarySubdivide (aX, aA, aB, mX1, mX2) {
  var currentX, currentT, i = 0;
  do {
    currentT = aA + (aB - aA) / 2.0;
    currentX = calcBezier(currentT, mX1, mX2) - aX;
    if (currentX > 0.0) {
      aB = currentT;
    } else {
      aA = currentT;
    }
  } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
  return currentT;
}

function newtonRaphsonIterate (aX, aGuessT, mX1, mX2) {
 for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
   var currentSlope = getSlope(aGuessT, mX1, mX2);
   if (currentSlope === 0.0) {
     return aGuessT;
   }
   var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
   aGuessT -= currentX / currentSlope;
 }
 return aGuessT;
}

module.exports = function bezier (mX1, mY1, mX2, mY2) {
  if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) {
    throw new Error('bezier x values must be in [0, 1] range');
  }

  // Precompute samples table
  var sampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
  if (mX1 !== mY1 || mX2 !== mY2) {
    for (var i = 0; i < kSplineTableSize; ++i) {
      sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
    }
  }

  function getTForX (aX) {
    var intervalStart = 0.0;
    var currentSample = 1;
    var lastSample = kSplineTableSize - 1;

    for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
      intervalStart += kSampleStepSize;
    }
    --currentSample;

    // Interpolate to provide an initial guess for t
    var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
    var guessForT = intervalStart + dist * kSampleStepSize;

    var initialSlope = getSlope(guessForT, mX1, mX2);
    if (initialSlope >= NEWTON_MIN_SLOPE) {
      return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
    } else if (initialSlope === 0.0) {
      return guessForT;
    } else {
      return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
    }
  }

  return function BezierEasing (x) {
    if (mX1 === mY1 && mX2 === mY2) {
      return x; // linear
    }
    // Because JavaScript number are imprecise, we should guarantee the extremes are right.
    if (x === 0) {
      return 0;
    }
    if (x === 1) {
      return 1;
    }
    return calcBezier(getTForX(x), mY1, mY2);
  };
};


/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// vue-scrollwatch.js